/* -------------Expand Sidebar------------*/

let openExpand = document.getElementById("openExpand");
let closeExpand = document.getElementById("closeExpand");
let expandBar = document.getElementById("mySidebar");
let featuredBlogs = document.querySelectorAll(".blogs-cards");

document.addEventListener("scroll",(e)=>{
  const banner = document.querySelector(".banner-image__wrapper")
  const header = document.querySelector(".header-wrapper")

   const headerBottom = header?.getBoundingClientRect().bottom
   const bannerBottom = banner?.getBoundingClientRect().bottom
   
   if(headerBottom > bannerBottom){
      if (document.querySelector("#mySidebar")){
        document.querySelector("#mySidebar").style.top = headerBottom + "px"
      }
   }else{
      if (document.querySelector("#mySidebar")){
        document.querySelector("#mySidebar").style.top = bannerBottom + "px"
      }
   }
})

// Open Exapnd Sidebar
let content = document.querySelectorAll(".blogs-page").forEach((each) => {
  openExpand?.addEventListener("click", () => {
    expandBar.classList.add("visible-sidebar");
    each.classList.add("open-sidebar");
    openExpand.classList.add("hide-expand-bar");
    featuredBlogs.forEach((ele) => ele.classList.add("expand-active"));
  });

  // Close Exapnd Sidebar
  closeExpand?.addEventListener("click", () => {
    expandBar.classList.remove("visible-sidebar");
    each.classList.add("close-sidebar");
    each.classList.remove("open-sidebar");
    featuredBlogs.forEach((ele) => ele.classList.remove("expand-active"));
    setTimeout(() => {
      openExpand.classList.remove("hide-expand-bar");
    }, 500);
  });
});
/* -------------sidebar------------*/

/*--------------Blog Filter----------*/
let filterButton = document.querySelector(".filter__container");
let filtersListContainer = document.querySelector(".article-collections__container");

let showFilters = localStorage.getItem("ShowFilters");
if (showFilters == "true") {
  filtersListContainer?.classList.add("show-filters");
  filterButton?.classList.add("show-filters");
} else {
  filtersListContainer?.classList.remove("show-filters");
  filterButton?.classList.remove("show-filters");
}

filterButton?.addEventListener("click", () => {
  if (filtersListContainer.classList.contains("show-filters")) {
    filtersListContainer.classList.remove("show-filters");
    filterButton.classList.remove("show-filters");
    showFilters = false;
  } else {
    filtersListContainer.classList.add("show-filters");
    filterButton.classList.add("show-filters");
    showFilters = true;
  }
  localStorage.setItem("ShowFilters", showFilters);
});

// Filters Search based on the title
let filterSearchInput = document.querySelector(".search-input__field");
let filterNoResults = document.querySelector(".filter-no-results");
var filtersItems_list = [];


function debounce(func, delay) {
  let timeoutId;

  return function(...args) {
    clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}
let recentArticleSearch = localStorage.getItem('recentArticleSearch');

function saveInStorage(query) {
  // Simulating an asynchronous API call
  if (query != '') {
    localStorage.setItem('recentArticleSearch', query)
  }
}
const debouncedSave = debounce(saveInStorage, 3000);
filterSearchInput?.addEventListener("keyup", function (event) {
  let filterSearchQuery = event.target.value.toLowerCase();
  let articleCard = document.getElementsByClassName("content-articles-card_wrapper");

  debouncedSave(filterSearchQuery)

  for (let i = 0; i < articleCard.length; i++) {
    const currentFilterName = articleCard[i].textContent.toLowerCase();

    // Search and Display the content
    if (currentFilterName.includes(filterSearchQuery)) {
      articleCard[i].style.display = "block";
    } else {
      articleCard[i].style.display = "none";
    }

    // To Show the search no results found
    let obj = {};
    obj.search_title = currentFilterName;
    filtersItems_list.push(obj);

    var filterList = filtersItems_list.filter(function (arr) {
      return arr.search_title.includes(filterSearchQuery);
    });

    if (filterList.length === 0) {
      filterNoResults.style.display = "flex";
    } else {
      filterNoResults.style.display = "none";
    }
  }
});

// Shopify MAIN SEARCH Value
const mainSearchInTemplate = document.getElementById('Search-In-Template');
if (mainSearchInTemplate?.value){
  debouncedSave(mainSearchInTemplate.value)
}


//MOBILE FILTERS
let mobileFilterButton = document.querySelector(".sticky-filter-bar");
let filtersCloseButton = document.querySelector(".filtersClose");
let mobilesFilters = document.querySelector(".mobile-blogs__filters");
window.addEventListener('DOMContentLoaded', () => {
  const mobileArticlesContainerEl = document.querySelector('.blogs-list__mobile');

  if (!mobileArticlesContainerEl && !mobileFilterButton) return;

  const mobileArticlesContainerElObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        mobileFilterButton.classList.add('active');
      } else {
        mobileFilterButton.classList.remove('active');
      }
    });
  }, {
    root: null, // viewport
    threshold: 0, // triggers even if 1px is visible
    rootMargin: `0px 0px -100px 0px` // shrink the bottom boundary by 100px
  });

  mobileArticlesContainerElObserver.observe(mobileArticlesContainerEl);
});
mobileFilterButton?.addEventListener("click", function () {
  if (mobilesFilters.classList.contains("show-mobile-filters")) {
    mobilesFilters.classList.remove("show-mobile-filters");
  } else {
    mobilesFilters.classList.add("show-mobile-filters");
  }
  if (window.innerWidth < 577) {
    document.querySelector("body").classList.toggle("mm-no-scroll");
    document.querySelector(".mm-ajaxcart-overlay").classList.toggle("mobile-filter-active");
  }
});

//CLOSE MOBILE FILTERS
filtersCloseButton?.addEventListener("click", () => {
  closeMobileFilters();
});

// SHOW SELECTED FILTER OPTION
let filterOption = document.querySelectorAll(".filter-option__name");
let mobileFiltersApplyBtn = document.querySelector(".apply-filter__button");
let currentTagsContainer = document.querySelector('.articles-filters__container')
let currentTags = currentTagsContainer?.dataset.currentTags

let lowerCase = currentTags?.toLowerCase()
let currentTagsArr = lowerCase?.split(',')
let handleize = currentTagsArr?.map(each => each.replace(' ','-'))
let handleizeTwo = handleize?.map(each => each.replace(' ','-'))

let tagsArr = []
if (currentTagsArr != '' ){
  tagsArr = handleizeTwo;
}
filterOption.forEach((eachOption) => {
  eachOption.addEventListener("click", () => {
    let tag = eachOption.dataset.option;
    blogUrl = eachOption.dataset.blogUrl;
    if (eachOption.classList.contains("selected-option")) {
      eachOption.classList.remove("selected-option");
      const index = tagsArr.indexOf(tag);
      tagsArr.splice(index, 1);
    } else {
      eachOption.classList.add("selected-option");
      tagsArr.push(tag);
    }
    const tagQuery = tagsArr.map((tag) => `${encodeURIComponent(tag)}`).join("+");
    let url = "";
    if (tagQuery != "") {
      url = `${blogUrl}/tagged/${tagQuery}`;
    } else {
      url = blogUrl;
    }
    if (window.innerWidth > 577) {
      fetchArticleData(url)
    }
    
  });
});
// MOBILE FILTERS APPLY 
mobileFiltersApplyBtn?.addEventListener("click", () => {
  const tagQuery = tagsArr.map((tag) => `${encodeURIComponent(tag)}`).join("+");
  appliedFiltersTag(tagsArr)
    let url = "";
    if (tagQuery != "") {
      url = `${blogUrl}/tagged/${tagQuery}`;
    } else {
      url = blogUrl;
    }
    fetchArticleData(url)
    closeMobileFilters();
  });

// FETCH ARTICLE DATA
function fetchArticleData(url) {
  fetch(url)
    .then((response) => response.text())
    .then((data) => {
      // Process the retrieved articles
      let newDoc = new DOMParser().parseFromString(data, "text/html");
      updateData(newDoc);
    });
  updateUrl(url);
}

//SHOW APPLIED FILTERS FOR MOBILE. CREATING APPLIED FILTERS TAGS AND REMOVE BUTTON
const mobileAppliedFiltersMainContainer = document.querySelector('.applied-filters__container')
const mobileAppliedFiltersContainer = document.querySelector('.mobile-applied-filters__container')
function appliedFiltersTag(tagsArr){
  const oldAppliedFilterTag = document.querySelectorAll(".applied-filter__tag").forEach((each)=> each.remove());

  // Use Map for O(1) lookups and avoid duplicates
  const tagMap = new Map();
  const filterOptions = document.querySelectorAll('.filter-option__name');
  
  filterOptions.forEach(option => {
    const dataOption = option.getAttribute('data-option');
    if (tagsArr.includes(dataOption) && !tagMap.has(dataOption)) {
      const text = option.childNodes[0].textContent.trim();
      const capitalizedText = text.toLowerCase().replace(/(^[a-z])|(?<=[\s-])[a-z]/g, match => match.toUpperCase());
      tagMap.set(dataOption, capitalizedText);
    }
  });
  
  const newTagsArr = Array.from(tagMap.keys());
  const newFiltersArr = Array.from(tagMap.values());
  const items = ['#E8DEBF','#E6EAD2','#DCE0ED','#f5dede','#d2e9ea','#dcede8']
  if (Array.isArray(newFiltersArr) && newFiltersArr.length > 0) {
    newFiltersArr.forEach((tag, index) => {
      const appliedTagEle = document.createElement('div');
      appliedTagEle.textContent = tag;
      appliedTagEle.classList.add('applied-filter__tag');

      const bgColor = items[Math.floor(Math.random() * items.length)];
      appliedTagEle.style.backgroundColor = bgColor;

      const filterRemoveButton = document.createElement('button');
      filterRemoveButton.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16 16">
          <g transform="translate(1.44 1)">
            <line x2="14" transform="translate(-0.44 7)" stroke="#1E1E1E" stroke-linecap="round" stroke-width="2"/>
            <line y1="14" transform="translate(6.56)" stroke="#1E1E1E" stroke-linecap="round" stroke-width="2"/>
          </g>
        </svg>`;
      filterRemoveButton.classList.add('applied-filter-remove_btn');
      filterRemoveButton.setAttribute('filter-tag', newTagsArr[index]);

      appliedTagEle.appendChild(filterRemoveButton);
      mobileAppliedFiltersContainer.appendChild(appliedTagEle);
    });

    mobileAppliedFiltersMainContainer?.classList.remove('hide-applied-filter');
  } else {
    mobileAppliedFiltersMainContainer?.classList.add('hide-applied-filter');
  }

  const removeButtons = document.querySelectorAll('.applied-filter-remove_btn');
  removeButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      removeAppliedTag(btn);
    });
  });
  const articleCardsContainer = document.querySelector('.blogs-list__mobile');
  if (articleCardsContainer) {
    const scrollMargin = -200; // pixels to offset from top of viewport (negative means scroll up)
    const targetScrollPosition = articleCardsContainer.getBoundingClientRect().top + window.pageYOffset + scrollMargin;
    window.scrollTo({ top: targetScrollPosition, behavior: 'smooth' });
  }
}
// CALING THE FUNCTION WHEN PAGE IS RELOAD
appliedFiltersTag(tagsArr)

// APPLIED FILTERS TAGS REMOVE AND UPDATE DATA
function removeAppliedTag(each){
  const filterTag = each.getAttribute('filter-tag');
  const activeFilterOptions = document.querySelectorAll('.filter-option__name')
  activeFilterOptions.forEach((eachActiveOption)=> {
    if (eachActiveOption.dataset.option == filterTag){
      eachActiveOption.classList.remove("selected-option");
    }
  })
  const index = tagsArr.indexOf(filterTag);
  tagsArr.splice(index, 1);
  const tagQuery = tagsArr.map((tag) => `${encodeURIComponent(tag)}`).join("+");
  const blogUrl = mobileAppliedFiltersContainer.getAttribute('data-blog-url')
  let url = ''
  if (tagQuery != "") {
    url = `${blogUrl}/tagged/${tagQuery}`;
  } else {
    url = blogUrl;
  }
  each.parentElement.remove()
  if (tagsArr == ''){
    mobileAppliedFiltersMainContainer.classList.add('hide-applied-filter');
  }else {
    mobileAppliedFiltersMainContainer.classList.remove('hide-applied-filter')
  }
  fetchArticleData(url);
}

// CLEAR APPLIED FILTERS IN DESKTOP
let clearAllFilters = document.querySelector(".clear-filter__button");
clearAllFilters?.addEventListener("click", () => {
  let handle = clearAllFilters.dataset.url;
  clearFilters(handle);
});

//CLEAR APPLIED FILTERS & FILTERS TAGS IN MOBILE
let resetFilters = document.querySelector(".reset-filters__button");
resetFilters?.addEventListener("click", () => {
  let handle = resetFilters.dataset.url;
  clearFilters(handle);
  closeMobileFilters();
  const appliedMobileFilters = document.querySelectorAll('.applied-filter__tag')
  appliedMobileFilters.forEach((each)=> each.remove());
  mobileAppliedFiltersMainContainer.classList.add('hide-applied-filter')

});

// CLEAR FILTERS
function clearFilters(handle) {
  tagsArr = [];
  let filterOption = document.querySelectorAll(".filter-option__name");
  filterOption.forEach((each) => {
    each.classList.remove("selected-option");
  });
  fetch(handle)
    .then((response) => response.text())
    .then((data) => {
      // Process the retrieved articles
      let newDoc = new DOMParser().parseFromString(data, "text/html");
      updateData(newDoc);
    });
  updateUrl(handle);
}
//UPDATE THE ARTICLES DATA
function updateData(newDoc) {
  let newData = newDoc.querySelector(".blog-article__list-content");
  
  const blogsList = document.querySelector('.blog-articles__list')
  const newBlogsList = newDoc.querySelector('.blog-articles__list')
  const oldCards = blogsList.querySelectorAll('.content-articles-card_wrapper')
  const newCards = newBlogsList.querySelectorAll('.content-articles-card_wrapper')

  oldCards.forEach((each)=> each.remove())
  newCards.forEach((each)=> {
    blogsList.appendChild(each)
  })
  articlesNoResults(newBlogsList);

  const newScrollContainer = newData.querySelector(".infinite-scroll-container")
  if (newScrollContainer) {
    nextPageUrl = newScrollContainer?.dataset.nextPage
    maximumPages = newScrollContainer?.dataset.maxPages
    desktopCurrentPage = newScrollContainer?.dataset.currentPage
    io.observe(newScrollContainer)
  }

  if (window.innerWidth < 577) {
    let previousMobileData = document.querySelector(".blogs-list__mobile");
    let newMobileData = newDoc.querySelector(".blogs-list__mobile");

    const mobileBlogsList = previousMobileData.querySelector('.mobile-article__list')
    const mobileOldCards = mobileBlogsList.querySelectorAll('.content-articles-card_wrapper')
    const mobileNewCards = newMobileData.querySelectorAll('.content-articles-card_wrapper')

    mobileOldCards.forEach((each)=> each.remove())
    mobileNewCards.forEach((each)=> {
      mobileBlogsList.appendChild(each)
    })

  const newMobileScrollContainer = newMobileData.querySelector(".infinite-scroll-container-mobile")
  if (newMobileScrollContainer) {
    mobileNextPageUrl = newMobileScrollContainer?.dataset.nextPage
    mobileMaximumPages = newMobileScrollContainer?.dataset.maxPages
    mobileCurrentPage = newMobileScrollContainer?.dataset.currentPage
    io.observe(newMobileScrollContainer)
  }
    articlesNoResults(newBlogsList);
  }
}

// CLOSE MOBILE FILTERS 
function closeMobileFilters() {
  mobilesFilters.classList.remove("show-mobile-filters");
  document.querySelector("body").classList.remove("mm-no-scroll");
  document.querySelector(".mm-ajaxcart-overlay").classList.remove("mobile-filter-active");
}
// SHOW NO RESULTS MESSAGE 
function articlesNoResults(newBlogsList) {
  let noResults = document.querySelectorAll('.article-no__results');
  if (newBlogsList?.innerHTML === ''){
    noResults.forEach(each=>{
      each.style.display = "flex";
    }) 
  } else {
    noResults.forEach(each=>{
      each.style.display = "none";
    }) 
  }
}
// CALING THE FUNCTION WHEN PAGE IS RELOAD
const newBlogsList = document.querySelector('.blog-articles__list')
articlesNoResults(newBlogsList);

//UPDATE THE URL
function updateUrl(url) {
  let newurl = window.location.protocol + "//" + window.location.host + url;
  window.history.pushState({ path: newurl }, "", newurl);
}

// INFINITE SCROLL
const infiniteScrollContainer = document.querySelector(".infinite-scroll-container")
const mobileInfiniteScroll = document.querySelector(".infinite-scroll-container-mobile")
const blogsList = document.querySelector('.blog-articles__list')
const mobileBlogsList = document.querySelector('.mobile-article__list')

let mobileMaximumPages = infiniteScrollContainer?.dataset.maxPages
let mobileNextPageUrl = infiniteScrollContainer?.dataset.nextPage
let mobileCurrentPage = infiniteScrollContainer?.dataset.currentPage

let maximumPages = infiniteScrollContainer?.dataset.maxPages
let nextPageUrl = infiniteScrollContainer?.dataset.nextPage
let desktopCurrentPage = infiniteScrollContainer?.dataset.currentPage

function addItems() {
  if (innerWidth > 578) {
    if (maximumPages > desktopCurrentPage) {
      fetch(nextPageUrl)
        .then((response) => response.text())
        .then((data) => {
          // Process the retrieved articles
          let newDoc = new DOMParser().parseFromString(data, "text/html");
          const newBlogsList = newDoc.querySelector('.blog-articles__list')
          const newCards = newBlogsList.querySelectorAll('.content-articles-card_wrapper')
          const newScrollContainer = newDoc.querySelector(".infinite-scroll-container")
          nextPageUrl = newScrollContainer?.dataset.nextPage
          desktopCurrentPage = newScrollContainer?.dataset.currentPage
          newCards.forEach((eachCard)=> {
            blogsList.appendChild(eachCard)
          })
        });
    } else {
      return;
    }
  }

  // MOBILE FETCH DATA
  if (innerWidth < 577){ 
    if (mobileMaximumPages > mobileCurrentPage) {
      fetch(mobileNextPageUrl)
        .then((response) => response.text())
        .then((data) => {
          // Process the retrieved articles
            let newDoc = new DOMParser().parseFromString(data, "text/html");
            const newMobileBlogsList = newDoc.querySelector('.mobile-article__list')
            const newMobileCards = newMobileBlogsList.querySelectorAll('.content-articles-card_wrapper')
            const newMobileScrollContainer = newDoc.querySelector(".infinite-scroll-container-mobile")
            mobileNextPageUrl = newMobileScrollContainer?.dataset.nextPage
            mobileCurrentPage = newMobileScrollContainer?.dataset.currentPage
            newMobileCards.forEach((eachCard)=> {
              mobileBlogsList.appendChild(eachCard)
            })
        });
    } else {
      return;
    }
  }
 
}
  const io = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) {
        return;
      }
      addItems();
    });
  },{
    root: null, // viewport
    rootMargin: '0px 0px 400px 0px', // Trigger when 200px before entering viewport
    threshold: 0
  });
  if (infiniteScrollContainer){
    io.observe(infiniteScrollContainer);
  }
  
  if (mobileInfiniteScroll) {
    io.observe(mobileInfiniteScroll);
  }

  // REALTED ARTICLE TWO MORE TAGS
  const twoMoreBtn = document.querySelectorAll('.two-more__tags');
  const ShowLessBtn = document.querySelectorAll('.show--less_tags');
  twoMoreBtn?.forEach((eachBtn)=> {
    eachBtn.addEventListener('click',()=> {
      const eachBtnParent = eachBtn.parentElement
      eachBtnParent.parentElement.classList.add('show-indi-tag')
    })
  })
  ShowLessBtn?.forEach((eachBtn)=> {
    eachBtn.addEventListener('click',()=> {
      const eachBtnParent = eachBtn.parentElement
      eachBtnParent.parentElement.classList.remove('show-indi-tag')
    })
  })
/*--------------Blog Filters-----------*/

class RecipePreparationTabs extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll('.preparations-instructions__tabs');
    this.tabs.forEach((tab)=> {
      tab.addEventListener('click',()=> {
        this.showContent(tab)
      });
    })
  };
  showContent(tab) { 
    const tabId = tab.dataset.tab
    this.contentDetails = this.querySelectorAll('.preparation-tab__details');
    this.tabs.forEach((each)=> each.classList.remove('recipe-tab-active'));
    tab.classList.add('recipe-tab-active');
    this.contentDetails.forEach((each)=> each.classList.remove('show-recipe-instructions'));
    this.contentEle = this.querySelector(`#${tabId}`);
    this.contentEle.classList.add('show-recipe-instructions')
  };
};
customElements.define("recipe-preparation-tabs", RecipePreparationTabs);

class SlurrpituPopup extends HTMLElement {
  constructor() {
    super();
    this.showPopupButton = this.querySelector('.slurrpitup-popup--button');
    this.closePopup = this.querySelector('.popup-close__icon');
    this.showPopupButton?.addEventListener('click', () => {
      this.showPopup();
    })
    this.closePopup?.addEventListener('click', () => {
      this.hidePopup();
    })
  }

  hidePopup() {
    this.querySelector('.slurrpitup-popup-main__container').classList.remove('show-siu-popup');
    document.querySelector('body').classList.remove('overflow-hidden');
  }
  showPopup() {
    this.querySelector('.slurrpitup-popup-main__container').classList.add('show-siu-popup');
    document.querySelector('body').classList.add('overflow-hidden');
  }

}

customElements.define("slurrpitup-popup", SlurrpituPopup);
